import React, { Component, Fragment } from "react";
import { arrayOf, bool, func, shape, string } from "prop-types";

import Container from "pages/_components/Container";
import Head from "pages/_components/Head";
import I18n from "pages/_components/I18n";
import MainContainer from "pages/_components/MainContainer";
import TemplateList from "pages/forms/_components/TemplateList";
import { connect } from "react-redux";
import { actions as formActions } from "reducers/form";
import { routerActions } from "react-router-redux/actions";
import { selectors as templateSelectors } from "reducers/template";

class Templates extends Component {
    static propTypes = {
        isFetching: bool.isRequired,
        dispatch: func.isRequired,
        templates: arrayOf(
            shape({
                name: string.isRequired,
            }),
        ).isRequired,
        match: shape({
            params: shape({
                formId: string,
            }),
        }).isRequired,
        customSelect: func,
        customBack: func,
    };

    static defaultProps = {
        customSelect: () => {},
        customBack: () => {},
    };

    handleSelect = (template) => {
        const { dispatch, match } = this.props;
        dispatch(routerActions.push(`/form/${match.params.formId}`));
        dispatch(formActions.setData(template));
    };

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(routerActions.goBack());
    };

    render() {
        const { isFetching, templates, customSelect, customBack } = this.props;

        return (
            <Fragment>
                <Head title="forms.templates.title" closeLinkTo="/desktop" onBack={customBack || this.handleBack} />
                <MainContainer>
                    <div className="above-the-fold">
                        <Container className="container--layout flex-grow-1" gridClassName="form-content">
                            <Container.Column xs={12} md={8} mdOffset={2} lg={6} lgOffset={3}>
                                <Container.ColumnBody>
                                    {!isFetching && templates.length === 0 && (
                                        <p className="text-lead">
                                            <I18n id="forms.templates.empty" />
                                        </p>
                                    )}
                                    <TemplateList
                                        onSelect={customSelect || this.handleSelect}
                                        className="navigational-list"
                                    />
                                </Container.ColumnBody>
                            </Container.Column>
                        </Container>
                    </div>
                </MainContainer>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    templates: templateSelectors.getTemplateList(state),
    isFetching: templateSelectors.isFetching(state),
});

export default connect(mapStateToProps)(Templates);
